// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img[data-v-5ecc31b6]{visibility:hidden;width:2.5rem;height:2.5rem;-o-object-fit:contain;object-fit:contain;padding:2px;max-width:none}img.is-loaded[data-v-5ecc31b6]{visibility:visible}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
